import clsx from 'clsx';
import {
  forwardRef, type InputHTMLAttributes, type ReactNode, type Ref
} from 'react';

import { Text } from '@/components/typography/text';

import styles from './input.module.scss';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  trailingAction?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      className,
      id,
      trailingAction,
      ...props
    },
    ref
  ) => {
    const inputId = id || `input-${ label?.toLowerCase().replace( /\s+/g, '-' ) }`;

    const inputClasses = clsx(
      styles.input,
      error && styles['input--error'],
      trailingAction && styles['input--with-trailing-action'],
      className
    );

    return (
      <div className={ styles.input_wrapper }>
        {label && (
          <Text as="label" htmlFor={ inputId } size="sm" weight="normal" className={ styles.label }>
            {label}
          </Text>
        )}
        <div className={ styles.input_container }>
          <input
            ref={ ref as Ref<HTMLInputElement> }
            id={ inputId }
            className={ inputClasses }
            { ...props }
          />
          {trailingAction && (
            <div className={ styles.trailing_action }>
              {trailingAction}
            </div>
          )}
        </div>
        {error && (
          <Text as="span" size="sm" weight="normal" className={ styles.error_message }>
            {error}
          </Text>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
